import React from 'react'
import * as C from './styles'

const Quote = () => {
  return (
    <C.Quote>
        <C.QuoteText>Um certo tipo de perfeição só pode ser atingido através de uma acumulação limitada de imperfeição.</C.QuoteText>
        <C.QuoteAuthor>Haruki Murakami</C.QuoteAuthor>
    </C.Quote>
  )
}

export default Quote